import { render, staticRenderFns } from "./LoginNotificationTemplate.vue?vue&type=template&id=58a19482&"
import script from "./LoginNotificationTemplate.vue?vue&type=script&lang=js&"
export * from "./LoginNotificationTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports